<template>
    <div class="table">
        <div class="container">
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-select v-model="form.deptId" placeholder="请选择学校" @change="common.page = 1;changeDept()">
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div style="display: inline-block; height:40px;"> 
                <el-date-picker
                    v-model="form.startDate"
                    type="date"
                    placeholder="开始时间"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd" style="width:150px;">
                </el-date-picker> 
                    
            </div>
            <div style="display: inline-block; height:40px;">
                <el-date-picker
                    v-model="form.endDate"
                    type="date"
                    placeholder="结束时间"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd" style="width:150px;">
                </el-date-picker> 
            </div>
            <el-select v-model="form.category1" clearable style="width:160px;" @change="getCategory2s" placeholder="请选择岗位">
                <el-option v-for="item in category1s" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            <el-select v-model="form.category2" v-if="category2s.length > 0"  clearable style="width:160px;" @change="getCategory3s" placeholder="请选择类型">
                <el-option v-for="item in category2s" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            <el-select v-model="form.category3" v-if="category3s.length > 0" clearable style="width:160px;"  placeholder="请选择岗位">
                <el-option v-for="item in category3s" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="form.name" placeholder="提交人"></el-input>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <el-button type="primary" @click="common.page = 1;getData()">查询</el-button>
                <el-button type="primary" @click="exportExcel()">导出</el-button>
                <el-button type="primary" icon="el-icon-download" @click="downloadBatchFiles()">附件打包下载</el-button>
            </div>
            <div style="display: inline-block; height:40px;float: right;">
                <el-button type="success" @click="queryDate(5)" v-if="form.dateType == 5">最近30天 </el-button>
                <el-button type="success" plain @click="queryDate(5)" v-if="form.dateType != 5">最近30天 </el-button>
                <el-button type="success" plain @click="queryDate(4)">最近7天</el-button>
                <el-button type="success" plain @click="queryDate(3)">昨天</el-button>
                <el-button type="success" plain @click="queryDate(2)">今天</el-button>
                <el-button type="success" plain @click="queryDate(6)">本周</el-button>
                <el-button type="success" plain @click="queryDate(7)">上周</el-button>
                <el-button type="success" plain @click="queryDate(1)">本月</el-button>
                <el-button type="success" plain @click="queryDate(0)">上月</el-button>
            </div>
            
            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="roleId"
                v-loading="loading"
                :element-loading-text="loadingText"
                element-loading-spinner="el-icon-loading"
                border
                default-expand-all>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="categoryName" label="岗位分类" :formatter="formatCategoryName" :show-overflow-tooltip="true" width="200"></el-table-column>
                <el-table-column prop="content" label="内容" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="giveCount" label="点赞数" width="80"></el-table-column>
                <el-table-column prop="commentCount" label="评论数"   width="80"></el-table-column>
                <el-table-column prop="gmtCreate" label="提交时间"  width="100"></el-table-column>
                <el-table-column prop="gmtmodified" label="更新时间"  width="100"></el-table-column>
                <el-table-column prop="createName" label="提交人"  width="100"></el-table-column>
                <el-table-column fixed="right" label="操作" width="70px" style="text-align:'left'">
                     <template slot-scope="scope">
                        <el-dropdown size="mini"
                            v-if="scope.row.fileCount>0 || scope.row.commentCount>0"
                            @command="(command) => handleCommand(command, scope.row)">
                            <el-button size="mini" type="text" icon="el-icon-d-arrow-right">更多</el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="handleLookFiles" v-if="scope.row.fileCount>0"
                                    icon="el-icon-circle-check">查看附件</el-dropdown-item>
                                <el-dropdown-item command="handleLookComments"  v-if="scope.row.commentCount>0"
                                    icon="el-icon-circle-check">查看评论</el-dropdown-item>
                                <el-dropdown-item command="handledownFiles"  v-if="scope.row.fileCount>0"
                                    icon="el-icon-download">附件下载</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>
        <!-- 查看附件弹出框 -->
        <div v-if="fileInfoVisible">
            <fileInfo ref="fileInfo"></fileInfo>
        </div>
        <!-- 查看评语弹出框 -->
        <div v-if="commentInfoVisible">
            <commentInfo ref="commentInfo"></commentInfo>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import http from '@/common/http'
    import fileInfo from './fileInfo.vue' 
    import commentInfo from './commentInfo.vue'

    export default {
        name:"",
        data(){
            return{
                loading: false,
                loadingText: "",
                fileInfoVisible: false,
                commentInfoVisible: false,
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    id:"",
                    deptId:"",
                    name:"",
                    startDate:"",
                    endDate:"",
                    category1: "",
                    category2: "",
                    category3: "",
                    dateType:5,
                },
                data: [],
                depts: [],
                categorys: [],
                category1s: [],
                category2s: [],
                category3s: [],
            }
        },
        components: {
            fileInfo, commentInfo
        },
        created:function () {
            this.getDeptData()
        },
        methods:{
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1)
            },
            // 更改学校配置安装
            changeDept(){
                this.getData()
                this.getCategoryDict()
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id
                        }
                        // 查询最近30天数据
                        this.queryDate(5)
                        // 查询岗位类型
                        this.getCategoryDict()
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                },(err)=>{
                    console.log(err)
                });
            },
            // 查询条件-获取岗位类型
            getCategoryDict(){
                // 清空上次选择的数据
                this.form.category1s = ""
                this.category1s = []

                let url  = this.getCategoryDictUrl;
                let data = { 
                    deptId: this.form.deptId,
                };
                // console.log("请求参数："+JSON.stringify(data));
                this.apiPost(url,data).then((res) => {
                    console.log(res.data);
                    if(res.status==200){ 
                        this.categorys = res.data
                        this.pushCategoryData(this.categorys, this.category1s)
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                },(err)=>{
                    console.log(err)
                });
            },
            // 查询条件-获取类型(二级)
            getCategory2s(){
                let tempCategorys = [];
                // 清空上次选择的数据
                this.form.category2 = ""
                this.category2s = []

                this.form.category3 = ""
                this.category3s = []

                for(let i=0; i<this.categorys.length;i++){
                    let category = this.categorys[i].label
                    if(this.form.category1 === category){
                        this.pushCategoryData(this.categorys[i].children, this.category2s)
                    }
                }
            },
            // 查询条件-获取类型（三级）
            getCategory3s(){
                let tempCategorys = [];
                this.form.category3 = ""
                this.category3s = []

                for(let i=0; i<this.categorys.length;i++){
                    let childrenCategory = this.categorys[i].children

                    let isHaveData = false
                    for(let j=0; j<childrenCategory.length;j++){
                        let category = childrenCategory[j].label
                        if(this.form.category2 === category){
                            this.pushCategoryData(childrenCategory[j].children, this.category3s)
                            isHaveData = true
                            break;
                        }
                    }

                    if(isHaveData){
                        break
                    }
                }
            },
            // 填充岗位类型数据
            pushCategoryData(sourceData, categoryData){
                for(let i=0; i<sourceData.length;i++){
                    let tempData = {}
                    tempData.value=sourceData[i].label
                    tempData.label=sourceData[i].label
                    categoryData.push(tempData)
                }
            },
            formatCategoryName(row, column, cellValue, index){
                return cellValue.replace(/\/$/, '')
            },
            getData(){
                if(this.form.startDate == null){
                    this.$commonFn.showTip('开始时间不可为空',3)
                    return
                }

                if(this.form.endDate == null){
                    this.$commonFn.showTip('结束时间不可为空',3)
                    return
                }

                this.loading=true
                this.loadingText="正在加载中..."

                let url  = this.patrolRecordListUrl;
                let data = { 
                    isPage: this.common.isPage,
                    page: this.common.page,
                    limit: this.common.pageSize,
                    deptId: this.form.deptId,
                    createName: this.form.name,
                    startDate: (this.form.startDate == null?"":this.form.startDate),
                    endDate: (this.form.endDate == null?"":this.form.endDate),
                    category1: this.form.category1,
                    category2: this.form.category2,
                    category3: this.form.category3
                };
                // console.log("请求参数："+JSON.stringify(data));
                this.apiPost(url,data).then((res) => {
                    // console.log(res.data);
                    if(res.status==200){
                        this.data = res.data.list
                        this.common.total=res.data.total
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                    this.loading=false
                },(err)=>{
                    console.log(err)
                    this.loading=false
                });
            },
            handleSizeChange(val) {
                this.common.pageSize = val
                this.common.page = 1
                this.getData()
            },
            handleCurrentChange(val) {
                this.common.page = val
                this.getData()
            },
            // 获取日期
            queryDate(dateType){
                // this.$forceUpdate();
                this.form.dateType=dateType
                let url  = this.honorSetQueryDateUrl
                let data = {
                    dateType:this.form.dateType //dateType:0-上月，1-本月，2-今天，3-昨天，4-最近7天，5-最近30天
                };
                // console.log(data);
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.form.startDate=res.data.startDate
                       this.form.endDate=res.data.endDate
                       // 查询数据
                       this.getData()
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                },(err)=>{
                    console.log(err)
                });
            },
            handleCommand(command, row) {
                // console.log("下拉框："+command);
                if(command == 'handleLookFiles'){
                    this.showFilesData(row)
                }else if(command == 'handleLookComments'){
                    this.showCommentsData(row)
                }else if(command == 'handledownFiles'){
                    this.downloadFiles(row);
                }
            },
            downloadFiles(row) {
                this.loading = true;
                this.loadingText = "正在下载中，下载过程时间可能会比较长，请耐心等待";

                let url = this.patrolToDownloadZipFileUrl;
                let param = new URLSearchParams();
                param.append('id', row.id);

                axios({
                    method: "post",
                    url: url,
                    data: param,
                    responseType: "blob"
                }).then(res => {
                    let data = res.data
                    var blob = new Blob([data])
                    // 创建下载的链接
                    var a = document.createElement('a');
                    a.style.display = 'none';
                    var href = window.URL.createObjectURL(blob);
                    a.href = href;
                    //显示下载文件名 获取后端返回的文件名
                    let filename = res.headers['content-disposition'].split('=')[1]
                    // 文件名中有中文 则对文件名进行转码 decodeURI
                    a.download = decodeURI(filename)
                    // 利用a标签做下载       
                    document.body.appendChild(a);
                    // 点击下载
                    a.click();
                    // 下载后移除元素
                    document.body.removeChild(a);
                    // 释放掉blob对象
                    window.URL.revokeObjectURL(href);
                    this.loading = false;
                }).catch(error => {
                    console.info('response.error' + error.message);
                    this.loading = false;
                });
            },
            downloadBatchFiles() {
                this.loading = true;
                this.loadingText = "正在下载中，下载过程时间可能会比较长，请耐心等待";

                let url = this.patrolToDownloadZiBatchFileUrl;
                let param = new URLSearchParams();
                param.append('deptId', this.form.deptId);
                param.append('createName', this.form.name);
                param.append('startDate', (this.form.startDate == null?"":this.form.startDate));
                param.append('endDate', (this.form.endDate == null?"":this.form.endDate));
                param.append('category1', this.form.category1);
                param.append('category2', this.form.category2);
                param.append('category3', this.form.category3);
 
                axios({
                    method: "post",
                    url: url,
                    data: param,
                    responseType: "blob"
                }).then(res => {
                    let data = res.data
                    var blob = new Blob([data])
                    // 创建下载的链接
                    var a = document.createElement('a');
                    a.style.display = 'none';
                    var href = window.URL.createObjectURL(blob);
                    a.href = href;
                    //显示下载文件名 获取后端返回的文件名
                    let filename = res.headers['content-disposition'].split('=')[1]
                    // 文件名中有中文 则对文件名进行转码 decodeURI
                    a.download = decodeURI(filename)
                    // 利用a标签做下载       
                    document.body.appendChild(a);
                    // 点击下载
                    a.click();
                    // 下载后移除元素
                    document.body.removeChild(a);
                    // 释放掉blob对象
                    window.URL.revokeObjectURL(href);
                    this.loading = false;
                }).catch(error => {
                    console.info('response.error' + error.message);
                    this.loading = false;
                });
            },
            showFilesData(row){
                this.fileInfoVisible=true
                this.$nextTick(() => { 
                    this.$refs['fileInfo'].init(row.id)
                })
            },
            showCommentsData(row){
                this.commentInfoVisible=true
                this.$nextTick(() => { 
                    this.$refs['commentInfo'].init(row.id)
                })
            },
            exportExcel(){
                if(this.form.startDate == null){
                    this.$commonFn.showTip('开始时间不可为空',3)
                    return
                }

                if(this.form.endDate == null){
                    this.$commonFn.showTip('结束时间不可为空',3)
                    return
                }
                const maxCount = 65535
                if(this.common.total > maxCount){
                    let msg="导出数据超出"+maxCount+"条平台不支持，请缩小数据范围查询，然后再进行导出操作！"
                    this.$commonFn.showTip(msg,3)
                }else{
                    this.exportData()
                }
            },
            // 导出报表数据
            exportData(data){
                this.loading=true
                this.loadingText="正在导出中，导出过程时间可能会比较长，请耐心等待"

                let url = this.patrolToExportExcelUrl
                let param = new URLSearchParams() 
                param.append('deptId', this.form.deptId)
                param.append('createName', this.form.name)
                param.append('startDate', (this.form.startDate == null?"":this.form.startDate))
                param.append('endDate', (this.form.endDate == null?"":this.form.endDate))
                param.append('category1', this.form.category1)
                param.append('category2', this.form.category2)
                param.append('category3', this.form.category3)
                
                let reg=new RegExp('-','g')
                let startDate=this.form.startDate.replace(reg,'.')
                let endDate=this.form.endDate.replace(reg,'.')
                let fileName="巡岗留痕"+"("+startDate+"-"+endDate+")"

                axios({
                    method: "post",
                    url: url,
                    data: param,
                    responseType: "blob"
                }).then(res => {
                    const link = document.createElement("a")
                    let blob = new Blob([res.data], { type: "application/vnd.ms-excel" })
                    link.style.display = "none";
                    link.href = URL.createObjectURL(blob)
                    link.setAttribute("download", fileName+'.xls')
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                    this.loading=false
                }).catch(error => {
                    console.log(error)
                    this.loading=false
                });

           },
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/evaluate/patrol/list.vue